<template>
  <div class="main-container">
    <div>
      <div class="register-header pt-12 md:pt-4 text-paua text-3xl md:text-6xl lg2:text-title lg3:text-6xl md:tracking-tighter xl:tracking-tight font-semibold text-center lg2:leading-12 lg3:leading-13">
        Register as a Buyer
      </div>
      <div style="font-weight: 500;" class="text-blue text-xl md:text-3xl lg2:text-2xl lg3:text-3xl font-medium text-center pt-4">
        You are registering as a Buyer so you can use BuyHive's <br class="md:hidden"/> sourcing services!
      </div>
    </div>
    <div class="pb-4 md:flex">
      <div class="lg:w-1/2 flex flex-col lg2:w-auto lg2:flex-grow px-10 lg2:pl-0 lg2:pr-10 items-center">
        <img src="@/assets/images/buyer.png" class="mt-12 md:mt-24 lg2:mt-10">
      </div>
      <div class="lg:w-1/2">
        <div class="bg-theme-blue px-4 md:pt-12 mt-8 lg2:mt-0 lg2:w-register-form rounded-lg">
        <ValidationObserver ref="formObserver" v-slot="{ handleSubmit }">
          <form @submit.prevent="handleSubmit(onSubmit)" class="signup-form">
            <div class="flex flex-wrap">
              <ValidationProvider
                v-slot="{ errors }"
                rules="required"
                class="pt-4 md:pt-0 block w-full md:w-1/2 md:pr-2"
              >
                <label class="text-sm">
                  First Name<span class="text-red-600">*</span>
                </label>
                <input
                  class="form-input"
                  type="text"
                  name="First Name"
                  placeholder="e.g. John"
                  v-model="formData.first_name"
                >
                <div class="input-error">{{ errors[0] }}</div>
              </ValidationProvider>
              <ValidationProvider
                v-slot="{ errors }"
                rules="required"
                class="block w-full md:w-1/2 md:pl-2"
              >
                <label class="text-sm">
                  Last Name<span class="text-red-600">*</span>
                </label>
                <input
                  class="form-input"
                  type="text"
                  name="Last Name"
                  placeholder="e.g. Doe"
                  v-model="formData.last_name"
                >
                <div class="input-error">{{ errors[0] }}</div>
              </ValidationProvider>
            </div>
            <div class="flex flex-wrap">
              <ValidationProvider
                v-slot="{ errors }"
                rules="required"
                class="block w-full md:w-1/2 md:pr-2"
              >
                <label class="text-sm">
                  Company Name<span class="text-red-600">*</span>
                </label>
                <input
                  class="form-input"
                  type="text"
                  placeholder="e.g. BuyHive Ltd."
                  name="Company Name"
                  v-model="formData.company_name"
                >
                <div class="input-error">{{ errors[0] }}</div>
              </ValidationProvider>
              <ValidationProvider
                v-slot="{ errors }"
                rules="required"
                name="Country/Region"
                class="block w-full md:w-1/2 md:pl-2"
              >
                <label class="text-sm">
                  Country/Region<span class="text-red-600">*</span>
                </label>
                <country-select
                  v-model="formData.country"
                  :country="formData.country"
                  placeholder="Select your Country/Region"
                  class="form-input focus:text-opacity-100"
                  :class="{'text-dark text-opacity-50': !formData.country}"
                  ref="countrySelect"
                  name="country"
                />
                <div class="input-error">{{ errors[0] }}</div>
              </ValidationProvider>
            </div>
            <div class="flex flex-wrap">
              <ValidationProvider
                v-slot="{ errors }"
                rules="required|email"
                class="block w-full md:w-1/2 md:pr-2"
              >
              <label class="text-sm">
                  Email<span class="text-red-600">*</span>
              </label>
                <input
                  class="form-input"
                  type="text"
                  placeholder="e.g. john@website.com"
                  name="Email"
                  v-model="formData.email"
                >
                <div class="input-error">{{ errors[0] }}</div>
              </ValidationProvider>
              <div class="w-full md:w-1/2 md:pl-2">
                <label class="text-sm">
                  Phone Number<span class="text-red-600">*</span>
                </label>
                <ValidationProvider
                  v-slot="{ errors }"
                  rules="required|max:16"
                  :mode="mode"
                  name="Phone Number"
                >
                  <VuePhoneNumberInput
                    v-model="formData.phone_number"
                    :default-country-code="formData.country"
                    @update="getPhoneNumber"
                    @phone-number-focused="changePhoneValidationMode"
                    class="h-12 phone-field"
                  />
                  <div class="text-sm text-red-500 input-error2">{{ errors[0] }}</div>
                </ValidationProvider>
              </div>
            </div>
            <div v-if="!linkedInRegister" class="flex flex-wrap">
              <ValidationProvider
                v-slot="{ errors }"
                rules="required|min:8"
                class="block w-full md:w-1/2 md:pr-2"
              >
              <label class="text-sm">
                Password<span class="text-red-600">*</span>
              </label>
                <input
                  class="form-input"
                  type="password"
                  placeholder="Password"
                  name="Password"
                  v-model="formData.password"
                >
                <div class="input-error">{{ errors[0] }}</div>
              </ValidationProvider>
              <ValidationProvider
                v-slot="{ errors }"
                :rules="`required|min:8|match:${formData.password}`"
                class="block w-full md:w-1/2 md:pl-2"
              >
              <label class="text-sm">
                Confirm Password<span class="text-red-600">*</span>
              </label>
                <input
                  class="form-input"
                  type="password"
                  placeholder="Confirm password"
                  name="Password"
                  v-model="formData.password_confirmation"
                >
                <div class="input-error">{{ errors[0] }}</div>
              </ValidationProvider>
            </div>
            <div class="flex flex-wrap">
              <ValidationProvider
                v-slot="{ errors }"
                :rules="{ required: { allowFalse: false } }"
                class="block w-full md:w-1/2 md:pr-2"
              >
                <div class="flex items-center">
                  <input value="" v-model="acceptTerms" type="checkbox" class="w-5 h-5">
                  <label
                    class="ml-2 cursor-pointer text-sm"
                    @click="acceptTerms = !acceptTerms"
                  >
                    I agree to
                    <a :href="termsLink" class="text-blue underline" target="_blank">
                      Terms of Service
                    </a>
                    <br>
                    and
                    <a :href="policyLink" class="text-blue underline" target="_blank">
                      Privacy Policy
                    </a>
                  </label>
                </div>
                <div class="input-error">
                  <span v-if="errors[0]">This field is required.</span>
                </div>
              </ValidationProvider>
              <div class="w-full md:w-1/2 md:pl-2">
                <VueRecaptcha
                  ref="recaptcha"
                  @verify="onVerify"
                  :sitekey="siteKey"
                  class="captcha -mx-3 md:mx-0"
                />
                <div class="input-error">
                  <p v-if="showError">
                    Please identify you are not robot
                  </p>
                </div>
              </div>
            </div>
            <div class="text-center md:pt-4">
              <button class="new-app-btn"
              :class="isRegisterDisabled ? 'disable-btn' : 'register-btn'" :disabled="isRegisterDisabled">
                Register
              </button>
            </div>
          </form>
          <div class="already-account pt-4 pb-4 md:pb-0 md:pb-8 text-center">
            Already have an account? 
            <button class="text-blue underline" style="font-weight: 500;" @click="openLoginForm">
              Sign In here!
            </button>
          </div>
        </ValidationObserver>
        </div>
        <div class="flex flex-wrap w-full justify-center">
            <div class="pt-8 text-medium text-center" style="font-size: 16px; line-height: 18.2px; font-weight: 600;">
                Do you want to register as <br class="md:hidden" /> a Sourcing Expert?
                <a
                  style="font-weight: 500;"
                  class="text-teal underline cursor-pointer"
                  @click="redirectSourcingExpertRegister"
                >Click here!</a>
              </div>
        </div> 
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions , mapGetters} from 'vuex'
import store from '@/store/index'
import VuePhoneNumberInput from 'vue-phone-number-input'
import 'vue-phone-number-input/dist/vue-phone-number-input.css'
// import { AsYouType  } from 'libphonenumber-js/max'
import VueRecaptcha from 'vue-recaptcha'

export default {
  name: 'Register',
  components: {
    VuePhoneNumberInput,
    VueRecaptcha
  },

  beforeRouteEnter: async (to, from, next) => {
    document.title = 'Buyer Registration | The BuyHive'
    if (store.getters.isUserLoggedIn && store.getters.getUserAuthInfo.role !== 'buyer') {
      next({ name: 'EmailVerification' })
    }
    else if (store.getters.isUserLoggedIn && store.getters.getUserAuthInfo.role === 'buyer') {
      next({ name: 'Home'})
    }
    next()
  },
  data() {
    return {
      formData: {
        email: '',
        company_name: '',
        first_name: '',
        last_name: '',
        phone_number: '',
        country_code: '',
        country: '',
      },
      isRegisterDisabled : false,
      linkedInRegister: false,
      acceptTerms: false,
      showError: false,
      robotVerify: false,
      mode: 'passive',
      policyLink: process.env.VUE_APP_PRIVACY_POLICY,
      termsLink: process.env.VUE_APP_BUYER_TERMS,
      topCountries: ['VN','TH','MY','ID','IN','HK','CN']
    }
  },
  mounted() {
    if (this.$route.query.access_token) {
      this.linkedInRegister = true
      this.formData.email = this.$route.query.email
      this.formData.first_name = this.$route.query.first_name
      this.formData.last_name = this.$route.query.last_name
      this.formData.linked_in_token = this.$route.query.access_token
    }
    this.setTopCountries()
  },
  computed: {
    ...mapGetters ([
      'isUserLoggedIn'
    ]),
    siteKey() {
      return process.env.VUE_APP_RECAPTCHA_KEY
    },
    country() {
      return this.formData.country
    }
  },
  watch: {
    'formData.country'() {
      this.changePhoneValidationMode()
    }
  },
  methods: {
  
    ...mapActions ([
      'register',
      'openAlertModal',
      'registerWithLinkedin',
      'LoginSelectionMode'
    ]),
    redirectSourcingExpertRegister() {
      window.location = `${process.env.VUE_APP_SERVER_BASE_URL}${process.env.VUE_APP_FREELANCER_REGISTER}`
    },
    setTopCountries() {
       const options = this.$refs.countrySelect.$el
      // for (const selectTag of options) {
        const placeHolderTag = options.firstChild
        const hk = options.querySelector('[value="HK"]')
        hk.innerHTML = 'Hong Kong SAR'
        this.topCountries.forEach(country => {
          const countryTag = options.querySelector(`[value=${country}`)
          placeHolderTag.after(countryTag)
        })
      // }
    },
    openLoginForm() {
      this.LoginSelectionMode('buyer');
      this.$router.push({name: 'LoginFormv2'})
    },
    async onSubmit() {
      this.isRegisterDisabled = true
      if (!this.robotVerify) {
        this.showError = true
        return
      }
      this.showError = false
      this.formData.phone_number = this.formData.phone_number.replace(/[^0-9]/g, '')

      const response = this.linkedInRegister
        ? await this.registerWithLinkedin(this.formData)
        : await this.register(this.formData)
        
      if (response.result && this.isUserLoggedIn) {
        if(this.$route.query.prev == '/checkout') {

          window.location = `${process.env.VUE_APP_BUYER_HOME_PATH}/checkout`
        }
        if (!['Home','Sourcing Request'].includes(this.$route.name)) {
          if(localStorage.getItem('previousUrl') && localStorage.getItem('existingSourcingToken')) {
            let sourcing_token = localStorage.getItem('existingSourcingToken')
            this.$store.commit('setSourcingRequestToken',sourcing_token)
            localStorage.removeItem('previousUrl')
            localStorage.removeItem('existingSourcingToken')
            this.$router.push({ name: 'Sourcing Request', query: { editing: true }})
          }else if(localStorage.getItem('previousUrl')) {
            let previous_url = localStorage.getItem('previousUrl')
            let temp_url = new URL(previous_url);
            localStorage.removeItem('existingSourcingToken')
            localStorage.removeItem('previousUrl')
            if(temp_url.pathname == '/u/sign-in' || temp_url.pathname == '/buy/u/sign-in' ||  temp_url.pathname == '/buy/u/register') {
              this.$router.push({ name: 'Home' })
            } else if(temp_url.pathname == '/expertsourcing/u/sign-in' || temp_url.pathname == '/expertsourcing/u/register'){
              window.location = process.env.VUE_APP_FREELANCER_HOME_PATH
            }else {
              window.location = previous_url
            }
          } 
          else {
            this.$router.push({ name: 'Home' })
          }
        }  else {
          this.$router.push({ name: 'Home' })
        }
      } else {
        this.$notify({
          group: 'buyHive',
          type: 'error',
          text: response.message
        });
      this.isRegisterDisabled = false
      }
    },
    getPhoneNumber(num) {
      this.formData.country_code = num.countryCallingCode
    },
    changePhoneValidationMode() {
      this.mode = 'passive'
      this.$nextTick(()=> {
        this.mode = 'aggressive'
      })
    },
    onVerify: function (response) {
      this.robotVerify = response ? true : false
      if (this.robotVerify) this.showError = false 
    }
  }
};
</script>
<style lang="scss" scoped>
.register-header {
  @media (min-width: 768px) {
    font-size: 60px; 
  }
  font-size: 40px;
  line-height: 48px;
  font-weight: 500;
  color: #201B57
}
.already-account {
  @media (min-width: 768px) {
    line-height: 21.86px;
    font-weight: 400;
  }
}
.input-error { 
  font-size: 12px;
  color: #FF0000;
  display: flex;
    justify-content: end;
}
.input-error2 { 
  font-size: 12px;
  color: #FF0000;
  display: flex;
    justify-content: end;
}
@import '@/assets/styles/variables.scss';
  .signup-form {
    .phone-field {
      font-family: "Avenir LT Pro";
      /deep/::placeholder {
        color: $gray_500 !important;
      }
      /deep/input.input-tel__input {
        font-family: 'Avenir LT Pro';
      }
      /deep/input.input-tel__input,
      /deep/input.country-selector__input {
        border-radius: 0.5rem !important;
        font-family: 'Avenir LT Pro';
        border-color: $dark-b !important;
        height: 48px !important;
        &:focus { box-shadow: none !important; }
      }
      /deep/label { color: $gray_500 !important; }
      /deep/.flex-1 { margin-left: 0.5rem; }
    }
    .captcha {
      /deep/div {
        @apply mx-auto;
        @screen md { @apply ml-0;  }
      }
    }
  }
.select-country-container {
  font-family: 'Avenir LT Pro';
}
.register-btn {
  background-color: #181D31;
  border-radius: 8px !important;
}
.disable-btn {
  background-color: #C4C4C4;
  border-radius: 8px !important;
}
</style>
